import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVehicleStockEcomItem } from 'sales-common';

interface VehicleDataState {
  vehicleData: IVehicleStockEcomItem;
}

const initialState: VehicleDataState = {
  vehicleData: {} as IVehicleStockEcomItem,
};

const vehicleDataSlice = createSlice({
  name: 'vehicleData',
  initialState,
  reducers: {
    setVehicleData: (state, action: PayloadAction<IVehicleStockEcomItem>) => {
      state.vehicleData = action.payload;
    },
  },
});

export const { setVehicleData } = vehicleDataSlice.actions;
export default vehicleDataSlice.reducer;
